module.exports = __webpack_public_path__ + "img/020051.f19321ed.png";